// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2P2seF7EsNRtVPgrUDdpUM
// Component: As-VifLuol
import * as React from "react";
import { Link } from "gatsby";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { useScreenVariants as useScreenVariantsvfX27Kk2D5M } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: VfX27Kk2d5M/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import * as projectcss from "./plasmic_isaacpalka_com.module.css"; // plasmic-import: 2P2seF7EsNRtVPgrUDdpUM/projectcss
import * as sty from "./PlasmicBlogPostPreview.module.css"; // plasmic-import: As-VifLuol/css

createPlasmicElementProxy;

export const PlasmicBlogPostPreview__VariantProps = new Array();

export const PlasmicBlogPostPreview__ArgProps = new Array(
  "title",
  "subheader",
  "excerpt",
  "destination"
);

const $$ = {};

function PlasmicBlogPostPreview__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsvfX27Kk2D5M()
  });
  return (
    <p.Stack
      as={p.PlasmicLink}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.a,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
      component={Link}
      href={args.destination}
      platform={"gatsby"}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        <div
          data-plasmic-name={"title"}
          data-plasmic-override={overrides.title}
          className={classNames(projectcss.all, sty.title)}
        >
          {p.renderPlasmicSlot({
            defaultContents: "Sample Blog Title",
            value: args.title,
            className: classNames(sty.slotTargetTitle)
          })}
        </div>
        <p.Stack
          as={"div"}
          data-plasmic-name={"rightSide"}
          data-plasmic-override={overrides.rightSide}
          hasGap={true}
          className={classNames(projectcss.all, sty.rightSide)}
        >
          {p.renderPlasmicSlot({
            defaultContents: "Jan 1, 2021 \u2022 8 min read",
            value: args.subheader,
            className: classNames(sty.slotTargetSubheader)
          })}
        </p.Stack>
      </p.Stack>
      <div
        data-plasmic-name={"excerpt"}
        data-plasmic-override={overrides.excerpt}
        className={classNames(projectcss.all, sty.excerpt)}
      >
        {p.renderPlasmicSlot({
          defaultContents:
            "Test title Sub title Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum id suscipit ante. Vestibulum pharetra libero tincidunt nisl semper pretium. Maecenas dictum tellus sed vestibulum euismod. Fusce non pretium diam. Donec tempor ut tortor ac venenatis. Praesent ornare ipsum odio, nec elementum turpis placerat in. Sed eget massa at odio ullamcorper molestie id placerat metus\u2026",
          value: args.excerpt,
          className: classNames(sty.slotTargetExcerpt)
        })}
      </div>
    </p.Stack>
  );
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "title", "rightSide", "excerpt"],
  freeBox: ["freeBox", "title", "rightSide"],
  title: ["title"],
  rightSide: ["rightSide"],
  excerpt: ["excerpt"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBlogPostPreview__ArgProps,
          internalVariantPropNames: PlasmicBlogPostPreview__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBlogPostPreview__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBlogPostPreview";
  } else {
    func.displayName = `PlasmicBlogPostPreview.${nodeName}`;
  }
  return func;
}

export const PlasmicBlogPostPreview = Object.assign(
  // Top-level PlasmicBlogPostPreview renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    title: makeNodeComponent("title"),
    rightSide: makeNodeComponent("rightSide"),
    excerpt: makeNodeComponent("excerpt"),
    // Metadata about props expected for PlasmicBlogPostPreview
    internalVariantProps: PlasmicBlogPostPreview__VariantProps,
    internalArgProps: PlasmicBlogPostPreview__ArgProps
  }
);

export default PlasmicBlogPostPreview;
/* prettier-ignore-end */
